// @TODO - E-4171 - Logic builder: limit rules, groups and depth

export const MAX_GROUP_DEPTH = 2;
